// const baseURL = "http://localhost:8080/bff-service/sg/v3/greatid/"; // for CORS
// const baseURL = "http://localhost:3000/"; // mock server
// const baseURL = "https://sit-sso-sgweb.ap.lifeisgreat.net"
//   "https://greatid-sit.apps.np.ap.lifeisgreat.net/bff-service/sg/v3/greatid/"; // REAL SIT
// Update baseURL based on the url in use
// const baseURL = window.location.href.includes(process.env.VUE_APP_API_FLAG) ?
// process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_API_DEFAULT;
// console.log(process.env.VUE_APP_API_FLAG, process.env.VUE_APP_BASE_API, process.env.VUE_APP_BASE_API_DEFAULT)
const protocol = window.location.protocol;
const hostname = window.location.hostname;
const countryList = {
  my: 'my',
  sg: 'sg',
};
  
const matchedCountry = Object.entries(countryList).find(([key, value]) =>
  hostname.toLowerCase().includes(key) || hostname.toLowerCase().includes(value)
);
 
const appCountry = matchedCountry ? matchedCountry[1] : 'sg';

let baseURL;
if (hostname === "localhost" || hostname === "mid.apps.tas-vsit.app-insurtech.com") {
  baseURL = `https://midvsitserver.apps.tas-vsit.app-insurtech.com/bff-service/${appCountry}/v1/memberid/`;
} else {
  baseURL =
    protocol + "//" + hostname + "/bff-service/" + appCountry + "/v1/memberid/";
}
const apiConstants = {
  LOGIN_API: baseURL + "signin",
  GET_MEMBER_ID: baseURL + "getMemberId",
  CHANGE_PASSWORD_API: baseURL + "changepassword",
  PUBLIC_KEY_API: baseURL + "mid/getRandom",
  SIGNUP: baseURL + "signup",
  VIEW_PROFILE: baseURL + "viewProfile", // not in use
  DELETE_ACCOUNT: baseURL + "deleteAccount", // not in use
  FORGOT_PASSWORD: baseURL + "forgotpassword",
  LOGOUT: baseURL + "logout",
  ISAM_ERROR: baseURL + "getIsamErrorMap",
  GET_TOKEN: baseURL + "token",
  GET_ERROR_CODE: baseURL + "getMemberIdErrorMap",
  FIDO_ISAM_API:
    protocol + "//" + hostname + "/mga/sps/apiauthsvc/policy/gelsgfidopasskey",
  DOWNTIME_URL:
    protocol + "//" + hostname + "/mga/sps/static/gelife/js/downtimemsg.json",
};

export default apiConstants;
